module.exports = __webpack_public_path__ + "static/img/weixin.d717bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/msg/img/weixin.png
// module id = w/S5
// module chunks = 2